<template>
  <section
    v-if="
      service.service_at_locations &&
      service.service_at_locations[0] &&
      service.service_at_locations[0].regular_schedule[0]
    "
    aria-role="region"
    aria-label="Session details"
    class="service-sessions"
  >
    <h3 class="h5">Session details:</h3>
    <b-list-group
      v-for="(serviceLocation, locIx) in groupedByLocations"
      :key="locIx"
      class="service-sessions-meta mb-3"
    >
      <b-list-group-item class="ical-wrap">
        <a v-if="displayIcalLink == true" :href="calendarLink" class="small mb-2">
          Add this session to my calendar <b-icon icon="calendar-plus"></b-icon>
        </a>
      </b-list-group-item>
      <span v-for="(regularSchedule, iX) in serviceLocation.schedule" :key="iX">
        <b-list-group-item
          v-for="(schedule, schedIx) in regularSchedule"
          :key="schedIx"
          class="session-date"
        >
          <span class="small mr-2"><b-icon icon="calendar3"></b-icon></span>
          <span class="meta-label">{{ schedule.freq }} - {{ schedule.description }}</span>
        </b-list-group-item>
      </span>
      <b-list-group-item>
        <address
          v-for="(address, aIndex) in serviceLocation.location.physical_addresses"
          :key="aIndex"
        >
          <span v-if="serviceLocation.location.name"
            >{{ serviceLocation.location.name }}<br
          /></span>
          <span v-if="address.address_1">{{ address.address_1 }}<br /></span>
          <span v-if="address.city">{{ address.city }}<br /></span>
          <span v-if="address.state_province">{{ address.state_province }}<br /></span>
          <span v-if="address.postal_code">{{ address.postal_code }}<br /></span>
        </address>
        <span v-if="serviceLocation.location.accessibility_for_disabilities.accessibility"
          >Accessibility: {{ serviceLocation.location.accessibility_for_disabilities.accessibility
          }}<br
        /></span>
        <router-link
          :to="{
            name: 'Location',
            params: {
              id: serviceLocation.location.id,
              name: encodeURIComponent(serviceLocation.location.name),
            },
          }"
          aria-label="View location information"
          itemprop="url"
        >
          View location information
        </router-link>
      </b-list-group-item>
    </b-list-group>
  </section>
</template>

<script>
import { APP_CONFIG } from '@/config/config'

export default {
  name: 'ServiceTimes',
  props: {
    service: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    groupedByLocations() {
      let groupedByLocations = {}
      if (
        this.service.service_at_locations &&
        this.service.service_at_locations[0] &&
        this.service.service_at_locations[0].regular_schedule[0]
      ) {
        this.service.service_at_locations.forEach((session) => {
          if (!groupedByLocations[session.location.id]) {
            groupedByLocations[session.location.id] = {}
            groupedByLocations[session.location.id].schedule = []
            groupedByLocations[session.location.id].location = session.location
          }
          groupedByLocations[session.location.id].schedule.push(session.regular_schedule)
        })
      }
      return groupedByLocations
    },
    calendarLink() {
      return APP_CONFIG.siteUrl + '/?service-ical=' + this.service.id
    },
    displayIcalLink() {
      let display = false

      this.service.service_at_locations.forEach((element) => {
        if (element.regular_schedule[0].freq && element.regular_schedule[0].freq) {
          display = true
        }
      })
      return display
    },
  },
}
</script>
